import React from 'react';
import Link from '@rezdy/components/Link';
import TextStyle from '@rezdy/components/TextStyle';
export const VendorAgreement = () => {
    // eslint-disable-next-line prettier/prettier
    return (
        <TextStyle weight="bold" size="small">
            I agree to{' '}
            <Link href="https://www.rezdy.com/vendor-agreement/" target="_blank">
                {"Rezdy's Vendor Agreement"}
            </Link>
        </TextStyle>
    );
};

export default VendorAgreement;
